
import Vue, { PropType } from 'vue';
import dayjs from '@/plugins/dayjs';

export default Vue.extend({
	props: {
		id: {
			type: String,
			default: 'default',
		},
		values: {
			type: Array as PropType<dayjs.Dayjs[]>,
			default: (): dayjs.Dayjs[] => [dayjs().utc(true).subtract(10, 'day')],
		},
		min: {
			type: Object as PropType<dayjs.Dayjs>,
			default: (): dayjs.Dayjs => dayjs().utc(true).subtract(10, 'day'),
		},
		max: {
			type: Object as PropType<dayjs.Dayjs>,
			default: (): dayjs.Dayjs => dayjs().utc(true),
		},
		interval: {
			type: Number,
			default: 1,
		},
		tooltipActivity: {
			type: String,
			default: 'active',
		},
		disable: {
			type: Boolean,
			default: false,
		},
		locale: {
			type: String,
			default: 'en-gb',
		},
		fixed: {
			type: Boolean,
			default: false,
		},
		dotSize: {
			type: Number,
			default: 20,
		},
		height: {
			type: Number,
			default: 12,
		},
		silent: {
			type: Boolean,
			default: true,
		},
	},

	computed: {
		minNum(): number {
			return this.getNumberFromDate(dayjs(this.min));
		},

		maxNum(): number {
			return this.getNumberFromDate(dayjs(this.max));
		},

		numValues(): number | number[] {
			if (this.values.length > 0) {
				let list = [];
				for (const value of this.values) {
					list.push(this.getNumberFromDate(value));
				}
				return list;
			} else {
				return this.getNumberFromDate(this.values[0]);
			}
		},
	},

	methods: {
		getDateFromNumber(number: number): dayjs.Dayjs {
			return dayjs(number).utc(false);
		},

		getNumberFromDate(date: dayjs.Dayjs): number {
			return date.valueOf();
		},

		formatDateFromNum(numVal: number): string {
			return dayjs(numVal).utc(false).locale(this.locale).format('DD/MM/YYYY HH:mm');
		},

		emitInput(newVal: number | number[]): void {
			let dates: dayjs.Dayjs[] = [];

			if (Array.isArray(newVal)) {
				for (const value of newVal) {
					dates.push(this.getDateFromNumber(value));
				}
			} else {
				dates.push(this.getDateFromNumber(newVal));
			}

			this.$emit('input', dates);
		},
	},
});
